import React from 'react';

import {useSelector} from 'react-redux';

import {loadingBarSelector} from './slice';
import {SweetLoadingBar, SweetLoadingBarCommonProps} from './SweetLoadingBar';

interface Props extends SweetLoadingBarCommonProps {
  scope?: string;
}

export function ConnectedSweetLoadingBar({scope}: Props): JSX.Element {
  const loading = useSelector((state) => loadingBarSelector(state, scope));
  return <SweetLoadingBar loading={loading} animationType="transform" />;
}
